import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Fuentes autoalojadas (OFL): sin peticiones a Google Fonts y versionadas con el build.
import "@fontsource-variable/figtree/wght.css";
import "@fontsource/henny-penny/latin-400.css";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Falta #root en index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
